import fp from 'lodash/fp';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import { push } from 'react-router-redux';
import { compose, lifecycle } from 'recompose';
import { bindActionCreators } from 'redux';
import { routes } from '../../constants';
import { isPublisher, isSystemOrSuperAdmin } from '../../services';
import { industryActions } from '../../state/modules/industry';
import { publisherPortalActions } from '../../state/modules/publisher-portal';
import { sessionActions } from '../../state/modules/session';
import { currentUserSelector, userActions } from '../../state/modules/user';
import { CourseDashboard, CourseDetails, Courses, Loading, NoMatch, PublishedEventDashboard, PublishedEventDetails, PublishedEventDuplicate, PublishedEvents, PublisherCompletedContent, PublisherContent, PublisherContentDetails, PublisherContentQuestion, PublisherPortal as Dashboard } from '../pages';
import { NoMatchNav, PublisherNav } from '../partials';

/**
 * Publisher portal layout component.
 */
class PublisherPortal extends Component {

  componentDidMount() {
    this.props.getUser();
    this.props.getUserIndustryRoles();
    this.props.getPublishers();

    if (!this.props.session.isAuthenticated) {
      this.props.goTo({ pathname: routes.login, state: { referrer: this.props.location } });
    }
  }

  withNavBar = (Component) => (props) =>
    <div className='clearfix'>
      <PublisherNav />
      <Component {...props} />
    </div>;

  render() {
    return this.props.currentUser.id ?
      this.props.isPublisher ?
        <div className='clearfix content-body'>
          <Switch>
            <Route exact path={routes.publisherPortal.dashboard} component={this.withNavBar(Dashboard)} />
            <Route exact path={routes.publisherPortal.content} component={this.withNavBar(PublisherContent)} />
            <Route exact path={routes.publisherPortal.completedContent} component={this.withNavBar(PublisherCompletedContent)} />
            <Route path={routes.publisherPortal.contentDetails} component={this.withNavBar(PublisherContentDetails)} />
            <Route exact path={routes.publisherPortal.publishedEventDashboard} component={this.withNavBar(PublishedEventDashboard)} />
            <Route path={routes.publisherPortal.publishedEventEdit(':publishedEventId')} component={this.withNavBar(PublishedEventDetails)} />
            <Route path={routes.publisherPortal.publishedEventDuplicate(':publishedEventId')} component={this.withNavBar(PublishedEventDuplicate)} />
            <Route exact path={routes.publisherPortal.publishedEvents} component={this.withNavBar(PublishedEvents)} />
            <Route exact path={routes.publisherPortal.publishedEventDetails} component={this.withNavBar(PublishedEventDetails)} />
            <Route path={routes.publisherPortal.contentQuestion} component={this.withNavBar(PublisherContentQuestion)} />
            <Route path={routes.publisherPortal.courseDashboard} component={this.withNavBar(CourseDashboard)} />
            <Route path={routes.publisherPortal.courses} component={this.withNavBar(Courses)} />
            <Route exact path={routes.publisherPortal.courseDetails} component={this.withNavBar(CourseDetails)} />
            <Route path={routes.publisherPortal.courseEdit(':publishedEventId')} component={this.withNavBar(CourseDetails)} />
            <Route component={() =>
              <div>
                <NoMatchNav />
                <NoMatch />
              </div>} />
          </Switch>
        </div> :
        <Redirect to={routes.app.dashboard} /> :
      <Loading />;
  };
}

const mapStateToProps = (state) => ({
  session: state.session,
  currentUser: currentUserSelector(state),
  isPublisher: fp.overSome([isPublisher, isSystemOrSuperAdmin])(currentUserSelector(state))
});

const mapDispatchToProps = (dispatch) => ({
  goTo: bindActionCreators(push, dispatch),
  logout: bindActionCreators(sessionActions.session.logout, dispatch),
  getUser: bindActionCreators(userActions.user.getCurrent, dispatch),
  getUserIndustryRoles: bindActionCreators(userActions.user.getIndustryRoles, dispatch),
  getPublishers: bindActionCreators(publisherPortalActions.publisherPortal.publishers.get, dispatch),
  getIndustriesWithCpdCategorys: bindActionCreators(industryActions.industries.industriesWithCpdCategorys, dispatch)
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      this.props.getIndustriesWithCpdCategorys()
    }
  })
)(PublisherPortal);



// WEBPACK FOOTER //
// ./src/containers/layouts/publisher-portal.js